import React from 'react';

const testimonials = [
  {
    quote: "Reduced our time-to-hire by 60% and dramatically improved team fit.",
    author: "Amanda Colaco",
    role: "General Manager at Wisenetix"
  },
  {
    quote: "The science-backed approach gives us confidence in every hiring decision.",
    author: "Iana Ferreira",
    role: "Head of Marketing at Wise Scale"
  },
  {
    quote: "Revolutionary tool. Our retention improved 40% since implementing it.",
    author: "Marcio Gonçalves",
    role: "Founder & CEO at WiseVAs"
  }
];

const HomeTestimonials = () => {
  return (
    <section id="testimonials" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16" style={{ letterSpacing: '-0.02em' }}>
          <span className="bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
            Loved
          </span>{' '}
          by teams
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-6 md:p-8 rounded-2xl border border-gray-200 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <p className="text-gray-700 mb-6 leading-relaxed text-lg">
                "{testimonial.quote}"
              </p>

              <div>
                <div className="font-semibold text-gray-900 text-sm">
                  {testimonial.author}
                </div>
                <div className="text-sm text-gray-600">
                  {testimonial.role}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
